import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import { useCallback, useEffect, useState } from 'react'
import { motion } from "framer-motion";

import './NewsOverview.css'
import './MNewsOverview.css'
import NewsCard from '../../../components/NewsCard'
import axios from 'axios';
import { URL_STRAPI, API_TOKEN_STRAPI, boxvar2dyndelay } from '../../../core.js'
import useInitialViewportVisibility from '../../../hooks/useInitialViewportVisibility.js'


export default function NewsOverview() {

    const [newsList, setNewsList] = useState(null);

    const fetchAllNews = async () => {
        try {
            const res = await axios.get(`${URL_STRAPI}/api/news-articles`, {
                params: {
                    'filters[active][$eq]': true,
                    'sort': 'newsdate:desc',
                    'populate': '*',
                },
                headers: {
                    Authorization: `Bearer ${API_TOKEN_STRAPI}`,
                },
                timeout: 5000, // Timeout nach 5 Sekunden
            });

            return res.data.data;
        } catch (err) {
            console.error('Fehler beim Laden der News:', err.message || err);
            return [];
            // throw err; 
            // oder: return []; wenn du leere Liste willst statt Exception
        }
    };

    useEffect(() => {
        fetchAllNews().then((content) => { setNewsList(content) });

    }, [])

    const getNewsId = useCallback((item) => item.newsid, []);
    const {
        setItemRef: setNewsItemRef,
        isInitiallyVisible: isNewsInitiallyVisible
    } = useInitialViewportVisibility(newsList || [], getNewsId, { resetKey: 'news-overview-cards' });


    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"news"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Neuigkeiten</title>
                <meta property="og:title" content="Neuigkeiten" />
                <meta property="og:description" content="Alle Neuigkeiten von ToNetwork" />
                <meta name="description" content="Alle Neuigkeiten von ToNetwork" />
            </Helmet>
            <section className='sec_next' id='sec_next--newsoverview'>
                <div className='sec_next_cont' id="sec_next--newsoverview--cont" style={{ wordBreak: "break-word" }}>
                    <br />
                    <h2>Neuigkeiten von ToN</h2>
                    <br />
                    <p>Hier findest du alle News rund um ToNetwork.</p>
                    <br /><br /><br /><br /><br /><br />

                    {(newsList == [] || newsList?.length == 0) ? <p>Es wurden keine News gefunden 👀</p> :
                        (newsList != null) ? newsList.map(function (newsdata, index) {
                            return (
                                <motion.div
                                    key={index}
                                    ref={setNewsItemRef(newsdata.newsid)}
                                    variants={boxvar2dyndelay}
                                    custom={isNewsInitiallyVisible(newsdata.newsid) ? 0.3 * (index + 1) : 0}
                                    initial="hidden"
                                    exit="hidden"
                                    whileInView="visible"
                                    viewport={{ once: false, margin: "-50px" }}
                                >

                                    <NewsCard newsid={newsdata.newsid} title={newsdata.title} datum={newsdata.newsdate} type={newsdata.type} subtitle={newsdata.subtitle} />
                                    <br /><br /><br />
                                </motion.div>
                            )
                        }) : <div>
                            <p>News werden geladen...</p>

                        </div>}
                    <br /><br /><br /><br /><br /><br /><br />
                    <br /><br /><br /><br /><br /><br /><br />

                </div>
            </section >

            <MainFooter />
        </div >
    )
}